import React from "react";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";

// Images
import Car from "./Car.png";
import marketplace from "./marketplace.png";
import inventory from "./inventory.png";
import ownership from "./ownership1.png";
import buying from "./buying.png";
import proof from "./proof.png";

// Vehicle images for the ROI carousel
import back1 from "./roi1.png";
import back2 from "./back2.png";
import back3 from "./back3.png";

// New images for the reasons section
import re1 from "./roi1.png";
import re2 from "./car2.jpg";
import re3 from "./car3.jpg";

// Import circle image
import circle from "./circle.png";

// Import rev2 image for the Hero Section replacement
import rev2 from "./rev2.png";

// Import graph1 image
import graph1 from "./graph1.png";

// Placeholder arrays for other carousel images; replace with actual image URLs or imports.
const carouselImages1 = [
  "path/to/image1.jpg",
  "path/to/image2.jpg",
  "path/to/image3.jpg"
];
const carouselImages2 = [
  "path/to/image4.jpg",
  "path/to/image5.jpg",
  "path/to/image6.jpg"
];

const reasons = [
  { 
    img: re1, 
    description: (
      <>
        One of the best examples of appreciation of cars is the La Ferrari Ferrari. It has appreciated <strong>14.7%</strong> the last 5 years.
      </>
    )
  },
  { 
    img: re2, 
    description: (
      <>
        Our Nissan Rogue got a <strong>120% ROI in 2 years</strong>. Bought for $8,000, made $14,000 revenue and then sold for $5,500.
      </>
    )
  },
  { 
    img: re3, 
    description: (
      <>
        Our best investment yet, this Chevy Malibu was bought for $4500, earned $12,000 revenue then exited for $3500. This resulted in an astonishing <strong>100% ROI in 1 year</strong>.
      </>
    )
  }
];

const vehicleSlides = [
  { src: back1, title: "La Ferrari", roi: "Appreciation 14.7% yr over the last 5 years" },
  { src: back2, title: "Vehicle 2", roi: "ROI: 18% annually" },
  { src: back3, title: "Vehicle 3", roi: "ROI: 22% annually" }
];

const WhyCarsPage = () => {
  return (
    <div style={{ backgroundColor: "#fff", fontFamily: "Helvetica, Arial, sans-serif", lineHeight: 1.6 }}>
      
      {/* New Introduction Section: ROI Discussion without Carousel */}
      <section
        style={{
          backgroundColor: "#fff",
          padding: "0px 20px",
          borderRadius: "10px",
          margin: "40px auto",
          maxWidth: "1000px",
          textAlign: "center"
        }}
      >
        <h2 style={{ fontSize: "4rem", color: "black", marginBottom: "20px" }}>
          Allocating vehicles diversifies your portfolio while generating additional income.
        </h2>
        <p style={{ fontSize: "1.2rem", color: "#555", marginBottom: "20px" }}>
          Lets remember why investment vehicles are called investment vehicles in the first place. You actually want your money to grow and your portfolio to go somewhere.
          You can diversify your portfolio by buying vehicles. Using AI we can hand-pick vehicles that have high potential returns by analyzing the market, historical data, health of the vehicle, damage and even predict when the vehicle will break down. The portfolio with vehicles allocated does 
          better than the traditional portfolio. 
        </p>
        <img 
          src={circle} 
          alt="Circle" 
          style={{ margin: "0 auto 40px", display: "block", maxWidth: "90%", height: "auto" }} 
        />
        
        {reasons.map((item, index) => (
          <div 
            key={index} 
            style={{ 
              display: 'flex', 
              flexDirection: index % 2 === 0 ? 'row' : 'row-reverse', 
              alignItems: 'center', 
              marginBottom: '40px'
            }}
          >
            <img 
              src={item.img} 
              alt={`Reason ${index + 1}`} 
              style={{ width: '35%', height: 'auto', objectFit: 'contain' }} 
            />
            <p 
              style={{ 
                width: '50%', 
                fontSize: '1.2rem', 
                color: '#333', 
                padding: '20px' 
              }}
            >
              {item.description}
            </p>
          </div>
        ))}

        <p style={{ fontSize: "1.2rem", color: "#333", marginBottom: "20px" }}>
          Rare and commuter vehicles have consistently proven to be profitable investments. 
          Unlike traditional assets, vehicles offer <strong>tangible value</strong>, unique appreciation potential, 
          and an additional revenue stream through rentals.
        </p>
        <p style={{ fontSize: "1.5rem", color: "#333", marginBottom: "20px" }}>
          <strong>The Value of Vehicles</strong><br/>
          <em><strong>Capital Appreciation:</strong></em> Many rare vehicles appreciate over time as their scarcity increases.<br/>
          <em><strong>Rental Income:</strong></em> Owners can generate steady monthly income by renting out their vehicles.<br/>
          <em><strong>Diversification:</strong></em> Investing in cars provides diversification outside of traditional stocks and real estate.<br/>
        </p>
        <img 
          src={graph1} 
          alt="Graph 1" 
          style={{ maxWidth: "100%", height: "auto", marginBottom: "20px" }} 
        />
      </section>
      
      {/* FAQ Section */}
      <section 
        style={{
          marginBottom: "100px",
          maxWidth: "800px",
          margin: "auto",
          padding: "20px",
          backgroundColor: "#1e1e1e",
          borderRadius: "10px"
        }}
      >
        <h2 style={{ fontSize: "36px", textAlign: "center", marginBottom: "20px", color: "white" }}>
          Frequently Asked Questions
        </h2>
        <details style={{ marginBottom: "10px" }}>
          <summary style={{ fontSize: "1.2rem", cursor: "pointer" }}>
            What exactly is Gier?
          </summary>
          <p>Gier is a tech startup that uses AI to help find and manage vehicle assets for investors. We host a platform for investors to purchase hand-picked rare, limited, or commuter vehicles that have high potential returns. We use AI to help us analyze the market, historical data, health of the vehicle, 
          damage and even predict when the vehicle will break down. You can use our AI Mechanic to help you analyze vehicles that you own or want to purchase.</p>
        </details>

        <details style={{ marginBottom: "10px" }}>
          <summary style={{ fontSize: "1.2rem", cursor: "pointer" }}>
            How do you use AI?
          </summary>
          <p>  The first use of AI is to help us analyze the vehicle market, historical data, needed repairs, and potential future issues. This gives us a good idea of what the vehicle is worth and helps us pick the best investments. 
      Another use of AI is to help us determine actual cost of damage in real time. This allows rental companies to dispute claims 
      before the customer leaves the lot. Finally we use AI to manage the overall health of the vehicle fleets. Our AI will keep a close eye on all vehicles including damage on the interior and exterior. This includes things like dents, scratches, and even the health of the engine. 
      Using AI we can also try to predict when certain parts will break down.  
      This results in higher returns, lower costs, less downtime, 
      more customization, better service, and  most importantly happier customers.</p>
        </details>
        <details style={{ marginBottom: "10px" }}>
          <summary style={{ fontSize: "1.2rem", cursor: "pointer" }}>
            How does insurance work?
          </summary>
          <p>Insurance will be paid for by the rental income of the vehicle. If it is a rare vehicle only for appreciation it will already be added to the listing price.</p>
        </details>
        <details style={{ marginBottom: "10px" }}>
          <summary style={{ fontSize: "1.2rem", cursor: "pointer" }}>
            What about damage?
          </summary>
          <p>Damage is actually good. We make money off damage claims and getting the vehicle repaired. Even things such as damage offer a way to extract more value from a vehicle.</p>
        </details>
        <details style={{ marginBottom: "10px" }}>
          <summary style={{ fontSize: "1.2rem", cursor: "pointer" }}>
            Is this crowdfunding?
          </summary>
          <p>GIER is not specifically a crowdfunding platform. We plan to have most vehicles already bought and renting before investors have a chance to buy them. If the vehicle is not owned and money is being raised that vehicle at that time is being crowdfunded.</p>
        </details>
        <details style={{ marginBottom: "10px" }}>
          <summary style={{ fontSize: "1.2rem", cursor: "pointer" }}>
            How long is the average investment?
          </summary>
          <p>We plan to hold each investment vehicle for 1-3 years. This could be shorter or longer depending on the potential to maximize profits.</p>
        </details>
        <details style={{ marginBottom: "10px" }}>
          <summary style={{ fontSize: "1.2rem", cursor: "pointer" }}>
            How do i get started?
          </summary>
          <p>Just create an account and head to the marketplace to purchase your first vehicle! It will show up on your profile after and you will start earning revenue!</p>
        </details>
      </section>

    {/* Hero Section */}
<section 
  style={{
    background: "linear-gradient(to right, #000, #1e1e1e, #000)",  // Sides fade effect
    color: "#fff",
    textAlign: "center",
    padding: "60px 20px",
    borderRadius: "10px",
    margin: "40px 0",
    boxShadow: "0 4px 12px rgba(0,0,0,0.4)"  // Added shadow for depth
  }}
>
  <h1 style={{ fontSize: "48px", fontWeight: "bold", marginBottom: "20px" }}>
    Invest in Cars with Confidence
  </h1>
  <img 
    src={rev2} 
    alt="Invest in Cars with Confidence" 
    style={{ 
      width: "70%", 
      display: "block", 
      borderRadius: "10px", 
      margin: "0 auto" 
    }} 
  />
</section>


      {/* Business Too Section */}
      <section
        style={{
          backgroundColor: "#fff",
          padding: "60px 20px",
          borderRadius: "10px",
          margin: "40px auto",
          maxWidth: "1000px",
          textAlign: "center"
        }}
      >
        <h2 style={{ fontSize: "3rem", color: "#333", marginBottom: "20px" }}>
          Investment Plan For Business Owners
        </h2>
        <div
  style={{
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-around",
    flexWrap: "wrap"
  }}
>
  <img
    src={inventory}
    alt="Business Solutions"
    style={{ width: "40%", height: "auto", objectFit: "contain", margin: "20px" }}
  />
  <div style={{ width: "50%", margin: "20px", fontSize: "1.2rem", color: "#555" }}>
    <p>
      We assist businesses in acquiring and managing fleets of high ROI and in-demand vehicles.
    </p>
    <div style={{ textAlign: "left", marginTop: "20px" }}>
      <div style={{ marginBottom: "15px" }}>
        <strong>Instead of rentals just being an expense, </strong>you can use them as a store of value. If you are spending $100,000 on 
        rental cars a year, you can now save that money and earn dividends.
      </div>
      <div style={{ marginBottom: "15px" }}>
        <strong>Customization:</strong> You can pick vehicles you want to rent, tailored to your needs.
      </div>
      <div style={{ marginBottom: "15px" }}>
        <strong>Cleaning:</strong> We only deliver the cleanest vehicles so <em><strong>your business looks good.</strong></em>
      </div>
    </div>
  </div>
</div>

      </section>

    </div>
  );
};

export default WhyCarsPage;
